export const PageHeader = ({ eyebrow, title, subtitle, children }) => (
  <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 fade-up">
    <div>
      {eyebrow && <div className="eyebrow mb-2">{eyebrow}</div>}
      <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-slate-900" data-testid="page-title">{title}</h1>
      {subtitle && <p className="text-sm text-slate-500 mt-2 max-w-2xl">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);

export const StatCard = ({ label, value, suffix, target, tone = "neutral", hint, testid, icon: Icon }) => {
  const color = { ok: "text-emerald-600", warn: "text-amber-600", bad: "text-red-600", neutral: "text-slate-900" }[tone];
  const bar = { ok: "bg-emerald-500", warn: "bg-amber-500", bad: "bg-red-500", neutral: "bg-slate-500" }[tone];
  return (
    <div className="panel p-5 relative overflow-hidden fade-up" data-testid={testid}>
      <div className={`absolute left-0 top-0 h-full w-[3px] ${bar}`} />
      <div className="flex items-start justify-between">
        <div className="eyebrow">{label}</div>
        {Icon && <Icon className="w-4 h-4 text-slate-500" />}
      </div>
      <div className={`mt-3 font-heading text-3xl font-bold tracking-tight ${color}`} data-testid={testid ? `${testid}-value` : undefined}>
        {value}
        {suffix && <span className="text-lg text-slate-500 ml-0.5">{suffix}</span>}
      </div>
      <div className="mt-2 flex items-center justify-between text-xs text-slate-500">
        <span>{hint}</span>
        {target && <span className="font-mono">Target {target}</span>}
      </div>
    </div>
  );
};
